var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancelEvent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4221_230872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 13.3333C73.3333 9.65656 70.3417 6.66656 66.6666 6.66656H56.6666V1.66656C56.6667 0.745469 55.9212 0 55 0C54.0788 0 53.3333 0.745469 53.3333 1.66672V6.66672H23.3333V1.66672C23.3333 0.745469 22.588 0 21.6667 0C20.7455 0 20 0.745469 20 1.66672V6.66672H6.66672C2.99156 6.66672 0 9.65656 0 13.3333V66.6666C0 70.3433 2.99156 73.3333 6.66672 73.3333H54.9969V73.3327L55.0002 73.3333C55.4331 73.3333 55.8595 73.1641 56.1786 72.845L72.8453 56.1783C73.1631 55.8592 73.2684 55.4334 73.2689 54.9998H73.3336V13.3333H73.3333Z",
    fill: "#460809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66937 10H20.0027V13.3333C18.1634 13.3333 16.6694 14.8291 16.6694 16.6666C16.6694 18.5041 18.1634 20 20.0027 20C21.8419 20 23.3359 18.5042 23.3359 16.6667V10H53.3359V13.3333C51.4967 13.3333 50.0027 14.8291 50.0027 16.6666C50.0027 18.5041 51.4969 20 53.3359 20C55.175 20 56.6692 18.5042 56.6692 16.6667V10H66.6692C68.5086 10 70.0027 11.4958 70.0027 13.3333V23.3333H3.33594V13.3333C3.33594 11.4958 4.83016 10 6.66937 10Z",
    fill: "#FFA2A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.3359 10H23.3359V11.6667H53.3359V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.66922 11.6667H20.0025V10H6.66922C4.83 10 3.33594 11.4958 3.33594 13.3333V15C3.33578 13.1625 4.83 11.6667 6.66922 11.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.6719 10H56.6719V11.6667H66.6719C68.5111 11.6667 70.0052 13.1625 70.0052 15V13.3333C70.0052 11.4958 68.5111 10 66.6719 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3358 59.9993V69.9993H6.66922C4.83 69.9993 3.33594 68.5035 3.33594 66.666V26.666H70.0025V53.3327H60.0025C56.3273 53.3326 53.3358 56.3226 53.3358 59.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6641 67.6426V59.9993C56.6641 58.1618 58.1583 56.666 59.9973 56.666H67.6406L56.6641 67.6426Z",
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3359 69.9993V59.9993C53.3359 56.3226 56.3275 53.3326 60.0027 53.3326H70.0027V26.666H3.33594L46.6694 69.9993H53.3359Z",
    fill: "#FFE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6692 79.9986C71.7944 79.9986 80.0025 71.7905 80.0025 61.6653C80.0025 51.5401 71.7944 43.332 61.6692 43.332C51.544 43.332 43.3359 51.5401 43.3359 61.6653C43.3359 71.7905 51.544 79.9986 61.6692 79.9986Z",
    fill: "#460809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6614 61.666C76.6614 65.201 75.3812 68.4109 73.3283 70.9776L52.3516 49.9979C54.9178 47.9455 58.1272 46.666 61.6614 46.666C69.9328 46.666 76.6614 53.3945 76.6614 61.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 61.6651C46.6641 58.1301 47.9442 54.9202 49.9972 52.3535L70.9739 73.3332C68.4077 75.3855 65.1983 76.6651 61.6641 76.6651C53.3925 76.6651 46.6641 69.9365 46.6641 61.6651Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4221_230872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancelEvent);
export default __webpack_public_path__ + "static/media/ic-cancel-event.4306df1e5e3b8ceafa24f6cfab346092.svg";
export { ForwardRef as ReactComponent };